import { Dropdown } from "react-bootstrap";

interface Option {
  value: string;
  label: string;
}

interface Props {
  options: Option[];
  value: string;
  onChange: (value: string) => void;
  label?: string;
  // Bootstrap Icon class. Defaults to the sort glyph; pass a filter glyph
  // (e.g. `bi-funnel`) when reusing this for status/category filters.
  icon?: string;
}

// Pill-styled dropdown used across listings (Explore, Followed sellers, and
// dashboard table filters). Shows a "{label} · {current}" toggle and a clean
// menu with a check next to the active option.
const SortDropdown: React.FC<Props> = ({
  options,
  value,
  onChange,
  label = "Sort by",
  icon = "bi-arrow-down-up",
}) => {
  const current = options.find((o) => o.value === value);

  return (
    <Dropdown align="end" className="sortPill">
      <Dropdown.Toggle as="button" type="button" className="sortPill__toggle">
        <i className={`bi ${icon}`} aria-hidden="true" />
        <span className="sortPill__label">{label}</span>
        <span className="sortPill__sep">·</span>
        <span className="sortPill__value">{current?.label ?? ""}</span>
        <i
          className="bi bi-chevron-down sortPill__chevron"
          aria-hidden="true"
        />
      </Dropdown.Toggle>
      <Dropdown.Menu className="sortPill__menu">
        {options.map((o) => {
          const isActive = o.value === value;
          return (
            <Dropdown.Item
              key={o.value}
              as="button"
              type="button"
              onClick={() => onChange(o.value)}
              className={`sortPill__item${
                isActive ? " sortPill__item--active" : ""
              }`}
            >
              <span>{o.label}</span>
              {isActive && (
                <i className="bi bi-check2 sortPill__check" aria-hidden="true" />
              )}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SortDropdown;
